import { render, staticRenderFns } from "./OnhandForm.vue?vue&type=template&id=b841e864"
import script from "./OnhandForm.vue?vue&type=script&lang=js"
export * from "./OnhandForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports